import PdfViewer from './PdfViewer';
import './App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState } from 'react';
import p1 from './p1 (1).jpg'
import p2 from './p1 (2).jpg'
import p3 from './p1 (3).jpg'
import p4 from './p1 (4).jpg'
import p5 from './p1 (5).jpg'
import p6 from './p1 (6).jpg'
import p7 from './p1 (7).jpg'
import p8 from './p1 (8).jpg'
import p9 from './p1 (9).jpg'
import p10 from './p1 (10).jpg'
import p11 from './p1 (11).jpg'
import p12 from './p1 (12).jpg'
import p13 from './p1 (13).jpg'
import p14 from './p1 (14).jpg'
import p15 from './p1 (15).jpg'

import ImageCarousel from './PicViewer';

function App() {
  let [images,setImages]=useState([]);
  useEffect(()=>{
    let temp=[]
    temp.push(p1);
    temp.push(p2);
    temp.push(p3);
    temp.push(p4);
    temp.push(p5);
    temp.push(p6);
    temp.push(p7);
    temp.push(p8);
    temp.push(p9);
    temp.push(p10);
    temp.push(p11);
    temp.push(p12);
    temp.push(p13);
    temp.push(p14);
    temp.push(p15);
    setImages(temp);
  },[])
  return (
    <div style={{height:'100vh',width:'100%',overflow:'auto'}} className="App">
      <h1 style={{padding:'0',margin:'0'}}>5smakat Menu</h1>
      <ImageCarousel images={images}/>
    </div>
  );
}

export default App;
